"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var memoize_1 = __importDefault(require("lodash/memoize"));
exports.isFirefox = memoize_1.default(function () {
    return /firefox/i.test(navigator.userAgent);
});
exports.isSafari = memoize_1.default(function () { return Boolean(window.safari); });
//# sourceMappingURL=BrowserDetector.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-dnd-html5-backend/lib/BrowserDetector.js
// module id = 390
// module chunks = 0